import React from 'react';
import {Stack} from '@mui/material';
import {designSystemToken} from '@lightricks/react-design-system';
import {Project} from '@contentlab/types/project';
import {ProjectStatusUpdate} from '@contentlab/types/projectStatusUpdate';
import ProjectRow from './ProjectRow';

interface ProjectsGroupProps {
  projects: Array<{
    project: Project;
    projectStatus: ProjectStatusUpdate;
  }>;
  presentationId: string;
}

function ProjectsGroup({projects, presentationId}: ProjectsGroupProps) {
  if (projects.length === 0) {
    return null;
  }

  return (
    <Stack
      direction="column"
      borderBottom={`1px solid ${designSystemToken('semantic.bg.tertiary')}`}
      paddingY="16px"
      gap="8px"
    >
      <Stack direction="column" gap="8px">
        {projects.map(({project, projectStatus}) => (
          <ProjectRow
            key={project.id}
            project={project}
            projectStatus={projectStatus}
            presentationId={presentationId}
          />
        ))}
      </Stack>
    </Stack>
  );
}

export default ProjectsGroup;
